export const CANCELLED_STATUS = 'Cancelled'
export const PENDING_STATUS = 'Pending'
export const PRODUCED_STATUS = 'Produced'
export const COMPLETE_STATUS = 'Complete'
export const CLOSED_STATUS = 'Closed'
export const SALES_ORDER_CREATED_STATUS = 'Sales Order Created'
export const SALES_ORDER_COMPLETED_STATUS = 'Sales Order Complete'
export const INVOICE_CREATED_STATUS = 'Invoice Created'
export const PROFORMA_STATUS = 'Pro Forma'
export const PRINTED_STATUS = 'Printed'
export const PACKAGING_RELEASED_STATUS = 'Packaging Released'
export const WAITING_STOCK_CARD_STATUS = 'Waiting for Stock Card'
